// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from './Classes/Lazyload';
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Accordion from './Classes/Accordion';
import CV from './Classes/CV';
import Header from './Classes/Header';
import Dropdowntoggler from './Classes/Dropdowntoggler';
import BackToTop from "./Classes/BackToTop";
import GoToNextSection from "./Classes/goToNextSection";
import countUpNumbers from './Classes/countUpNumbers';
import XDownloader from './Classes/XDownloader';
import Animate from './Classes/Animate';
import KeyfiguresTabs from './Classes/KeyfiguresTabs';
import KeyfiguresAnimation from './Classes/KeyfiguresAnimation';
import HeroAnimation from './Classes/HeroAnimation';
import KeyMomentsSlider from './Classes/KeyMomentsSlider';
import BannerSVG from './Classes/BannerSVG';
import Reveal from './Classes/Reveal';

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';

export default NSTheme;

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    new Animate();

    new XDownloader({
      downloadText: "XLSX Download", //Can be empty if you want to use an icon instead
      backgroundColor: "c7e0ed", //Colored Cells Background
      backgroundClass: 'ns-background-05', //Class of colored cells
      borderColor: '333333', //Color of border
      borderColor2: '333333',
      borderStyle: 'thin', // thin/dotted/medium/double/thick
      borderStyle2: 'thin', // thin/dotted/medium/double/thick
      headClass: 'head', //Class you want your columns based on. Will be bold in Excel
      boldClass: 'line_bold', //Class for Bold text in Excel
      boldClass2: 'bline_bold', //Class for Bold text in Excel
      boldClass3: 'bold', //Class for Bold text in Excel
      borderClass: 'ns-horizontal-left',
      borderClass2: 'ns-horizontal-right'
    });

    new FocusHandler();

    new LazyLoad();

    new Header({
      mobileNavToggleSelector: '.js-toggle-main-menu',
      mainMenuContainerSelector: '.header__menu',
      submenuToggleSelector: '.js-nav-dropdown-toggler',
      submenuBackToggleSelector: '.js-menu-item-back',
      searchOpenSelector: '.js-search-trigger',
      searchCloseSelector: '.js-search-close',
    });

    new Dropdowntoggler({
      dropdownWrapperSelector: '.js-dropdown-wrapper',
      dropdownToggleSelector: '.js-dropdown-toggle',
      dropdownDropSelector: '.js-dropdown',
      needsBackdrop: true
    });

     new ResponsiveTablesLight({
      tableComponentSelector: '.ns-table-wrap',
      tableContainerSelector: '.srl-table-container',
      tableSelector: '.ns-table-wrap table'
    });

    new BackToTop({
      buttonClass: '.js-backtotop-toggle',
      stickyClass: '.prev-next__inner',
      fadeInPosition: 500,
      correction: 121
    });

    // new Jump({
      //   graphicSelector: '.ns-graphic'
      // });

    new Accordion({
      accordions: '.js-accordion-trigger'
    });

    new CV({
      trigger: '.js-text-trigger'
    });


    new GoToNextSection({
      button: '.ns-header-image__btn-goto-next-section',
      parent: '.ns-header-image'
    });

    new countUpNumbers({
      numbers: '.ns-keyfigures__number',
      numbersWrapper: 'ns-keyfigures', //add classname without point in front
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      decimalEN: '.',
      decimalDE: ',',
      decimalFR: ',',
      separatorEN: ',',
      separatorDE: ' ',
      separatorFR: ' '
    });

    new KeyfiguresTabs({
      tabs: '.ns-keyfigures-tabs'
    });

    new KeyfiguresAnimation();

    new HeroAnimation();

    new KeyMomentsSlider();

    new BannerSVG();

    const reveal = new Reveal();

    reveal.addContainer(
      'ns-quote-container',
      ['ns-quote__img-wrapper', 'ns-quote__quote-wrapper'],
      300
    );

    reveal.addContainer(
      'ns-keyfigures-tabs',
      ['ns-keyfigures-tabs__title', 'ns-keyfigures-tabs__tabs-nav', 'ns-keyfigures-tabs__tab-content'],
      300
    );

    reveal.addContainer(
      'ns-keyfigures-animation',
      ['ns-keyfigures-animation__container'],
      300
    );

    reveal.addContainer(
      'ns-key-moments__container',
      ['ns-key-moments__title', 'ns-key-moments__slider'],
      300
    );

    reveal.addContainer(
      'ns-banner',
      ['ns-banner__polygon', 'ns-banner__content'],
      300
    );

  })
})();
